// 1×1 transparent PNG — used as a harmless placeholder so Fabric can create the
// FabricImage object without attempting to load a video URL as an <img>.
export const TRANSPARENT_PIXEL =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
